<script>
  import { fade } from 'svelte/transition'

  let isOpen = false;
  let body = document.querySelector('body')

  function openMenu() {
    isOpen = true;
    body.style.overflow = 'hidden'
  }

  function closeMenu() {
    isOpen = false;
    body.style.overflow = 'initial'
  }

  import { _ } from './services/i18n';
	import { setupI18n, locale } from './services/i18n';
  import LocaleSwitcher from './LocaleSwitcher.svelte';

</script>

<header class={isOpen ? "header hide-bg" : "header"}>
  <nav class="nav">
    <LocaleSwitcher value={$locale}
    on:locale-changed={e => setupI18n({ withLocale: e.detail }) }/>
    {#if !isOpen}
      <i class="fa-solid fa-bars" id="hamburger" on:click={openMenu} />
    {/if}
    <ul class="nav-ul">
      <li class="list-item"><a href="#about">{$_('nav.about')}</a></li>
      <li class="list-item"><a href="#whyUs">{$_('nav.whyus')}</a></li>
      <li class="list-item"><a href="#services">{$_('nav.services')}</a></li>
      <li class="list-item"><a href="#authors">{$_('nav.authors')}</a></li>
      <li class="list-item"><a href="#reviews">{$_('nav.reviews')}</a></li>
      <li class="list-item"><a href="#contacts">{$_('nav.contacts')}</a></li>
    </ul>
    {#if isOpen}
    <ul class="mobile-nav-ul" transition:fade="{{duration: 300}}">
      <i class="fa-solid fa-xmark" on:click={closeMenu}></i>
      <li class="list-item"><a on:click={closeMenu} href="#about">{$_('nav.about')}</a></li>
      <li class="list-item"><a on:click={closeMenu} href="#whyUs">{$_('nav.whyus')}</a></li>
      <li class="list-item"><a on:click={closeMenu} href="#services">{$_('nav.services')}</a></li>
      <li class="list-item"><a on:click={closeMenu} href="#authors">{$_('nav.authors')}</a></li>
      <li class="list-item"><a on:click={closeMenu} href="#reviews">{$_('nav.reviews')}</a></li>
      <li class="list-item"><a on:click={closeMenu} href="#contacts">{$_('nav.contacts')}</a></li>
    </ul>
    {/if}
  </nav>
</header>

<style>
  .header {
    background-color: var(--headerColor);
    position: fixed;
    min-height: 75px;
    width: 100%;
    z-index: 9999;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .hide-bg {
    background-color: transparent;
  }
  .header a {
    color: var(--mainWhite);
    transition: all 500ms ease-in-out;
    /* text-transform: lowercase; */
    font-weight: 500;
    font-size: 1.25rem;
    letter-spacing: 2px;
    position: relative;
  }
  .header a::before {
    content: '';
    position: absolute;
    left: 0px;
    bottom: -3px;
    width: 100%;
    height: 3px;
    background-color: rgb(255, 255, 255);
    opacity: 0;
    transform: translateY(10px);
    transition: all 300ms ease-in 0s;
  }
  .header a:hover::before {
    transform: translateY(0px);
    opacity: 1;
  }
  .nav {
    display: flex;
    align-items: center;
    flex-direction: column;
  }
  .nav-ul {
    display: flex;
  }
  .list-item {
    padding: 0 1rem;
  }
  .mobile-nav-ul {
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    right: 0;
    width: 100vw;
    height: 100vh;
    background: var(--headerColor);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 1rem;
  }
  .mobile-nav-ul li {
    padding-bottom: 0.5rem;
  }
  .fa-solid {
    font-size: 1.5rem;
    color: var(--mainWhite);
    position: absolute;
    top: 2.5rem;
    z-index: 4;
    right: 1rem;
    transform: translateY(-50%);
    transition: all 300ms ease-in-out;
    cursor: pointer;
  }
  .fa-solid.fa-xmark {
    right: 2rem;
  }
  @media (max-width: 1020px) {    
    .nav-ul {
      display: none;
    }
  }
  @media (min-width: 1020px) {
    .header {
      background-color: var(--headerColor) !important;
    }
    i {
      display: none;
    }
    .mobile-nav-ul {
      display: none !important;
    }
  }
</style>
